module.exports = __webpack_public_path__ + "06d4ca84387387a1576996218c3229b6.jpg";